import { Link } from "react-router-dom";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function LinkOrAnchor(props) {
  var { children, to } = props;

  if (to.indexOf("://") === -1) {
    return (
      <Link {...props}>
        {children}
      </Link>
    );
  } else {
    return (
      <a href={to} {...props}>
        {children}
      </a>
    );
  }
});
